import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { Vue } from 'vue-class-component';
var WLabel = /*#__PURE__*/function (_Vue) {
  function WLabel() {
    _classCallCheck(this, WLabel);
    return _callSuper(this, WLabel, arguments);
  }
  _inherits(WLabel, _Vue);
  return _createClass(WLabel);
}(Vue);
export { WLabel as default };